import { Link, StyleSheet, Text } from '@react-pdf/renderer';
import React from 'react';

import { resolveFieldToken } from './markerResolver';
import { parse, Token } from './markers';

const pdfStyles = StyleSheet.create({
  text: { fontSize: 10, lineHeight: 1.4, marginBottom: 12 },
  bold: { fontWeight: '700' },
});

export interface PdfMarkerTextProps {
  text: string;
  fieldValues: Record<string, string>;
  fieldPlaceholders: Record<string, string>;
  riders: string[];
  carrierDisplayName: string;
  blockId?: string;
}

function renderTokens(
  tokens: Token[],
  fieldValues: Record<string, string>,
  fieldPlaceholders: Record<string, string>,
  riders: string[],
  carrierDisplayName: string,
  blockId?: string,
): React.ReactNode[] {
  const out: React.ReactNode[] = [];
  tokens.forEach((tok, idx) => {
    if (tok.kind === 'text') {
      out.push(tok.value);
      return;
    }
    if (tok.kind === 'bold') {
      out.push(
        <Text key={idx} style={pdfStyles.bold}>
          {tok.value}
        </Text>,
      );
      return;
    }
    if (tok.kind === 'link') {
      out.push(
        <Link key={idx} href={tok.href}>
          {tok.label}
        </Link>,
      );
      return;
    }
    const resolved = resolveFieldToken({
      key: tok.key,
      fieldValues,
      fieldPlaceholders,
      riders,
      carrierDisplayName,
      blockId,
    });
    // Trunk JSX rendered unfilled fields as empty string (formData[X] === '').
    // PDF generation is gated on validation so this is reachable only in
    // edge cases, but matching trunk avoids bracket-text drift.
    out.push(resolved.isFilled ? resolved.value : '');
  });
  return out;
}

export const PdfMarkerText = ({
  text,
  fieldValues,
  fieldPlaceholders,
  riders,
  carrierDisplayName,
  blockId,
}: PdfMarkerTextProps) => {
  const tokens = parse(text);
  return (
    <Text style={pdfStyles.text}>
      {renderTokens(
        tokens,
        fieldValues,
        fieldPlaceholders,
        riders,
        carrierDisplayName,
        blockId,
      )}
    </Text>
  );
};
